<template>
  <div>{{ value }}</div>
</template>

<script>
  export default {
    props: {
      filter: {
        type: String,
        required: true
      },
      value: {
        type: [Object, String],
        required: true
      }
    }
  }
</script>
